<div class="container">
    <!-- Header usando componente shared -->
    <app-page-header
        title="Consultar OTP"
        subtitle="Obtén códigos de verificación temporal"
        icon="shield">
    </app-page-header>

    <div class="form-alert form-alert--error" *ngIf="showAlertError">
        <i class="form-alert-icon">⚠</i>
        <span>{{ errorMessage }}</span>
    </div>
    <section class="get-otp">
        <div class="form-container">
            <form class="form-wrapper" #getOtpForm="ngForm" (ngSubmit)="onSubmit(getOtpForm)">
                <div class="form-content">
                    <div class="form-row form-row--single">
                        <div class="form-group">
                            <label for="rol" class="form-label form-label--required">Obtener otp por </label>
                            <select type="text" id="inputs" name="rol" #rol="ngModel" [(ngModel)]="consultType" required
                                class="form-input form-select"
                                [ngClass]="{'form-input--error': rol.invalid && rol.touched}">
                                <option *ngFor="let cType of consultTypes" [value]="cType">{{cType}}</option>
                            </select>
                            <div *ngIf="rol.invalid && rol.touched" class="form-error-message">
                                <i class="form-error-icon">&#9888;</i>
                                <span class="form-error-text">Este campo es requerido!</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-row form-row--single">
                        <div class="form-group" *ngIf="consultType == 'Correo'">
                            <label for="email" class="form-label form-label--required">Email</label>
                            <input type="email" id="email" class="form-input" 
                                [ngClass]="{'form-input--error': !isEmailValid && email.touched}"
                                placeholder="Ingresa email"
                                [(ngModel)]="getOtpRequest.email" name="email" #email="ngModel" required
                                (blur)="validateEmail()">

                            <div *ngIf="!isEmailValid && email.touched" class="form-error-message">
                                <i class="form-error-icon">&#9888;</i>
                                <span class="form-error-text">{{emailError}}</span>
                            </div>
                        </div>
                        <div class="form-group" *ngIf="consultType == 'Celular'">
                            <label for="phone" class="form-label form-label--required">Celular</label>
                            <input type="tel" id="phone" class="form-input" 
                                [ngClass]="{'form-input--error': phoneModel.invalid && phoneModel.touched}"
                                placeholder="Ingresa número"
                                [(ngModel)]="getOtpRequest.phone_number" name="phoneInput" #phoneModel="ngModel"
                                required>
                            <div *ngIf="phoneModel.invalid && phoneModel.touched" class="form-error-message">
                                <i class="form-error-icon">&#9888;</i>
                                <span class="form-error-text">Este campo es requerido!</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-actions">
                    <button type="button" class="form-btn form-btn--cancel" (click)="cancel(getOtpForm)"
                        [ngClass]="{'is-active': getOtpForm.valid && isEmailValid}">Cancelar</button>
                    <button type="submit" class="form-btn form-btn--submit"
                        [ngClass]="{'is-valid': getOtpForm.valid && isEmailValid}"
                        [disabled]="(getOtpForm.invalid || !isEmailValid)">Obtener OTP</button>
                </div>
            </form>
        </div>
    </section>
    <app-confirmation-modal [isVisible]="isModalVisible" [confirmationText]="otpConsulText" 
        [confirmationType]="'get-otp'" [valueToCopy]="getOtpResponse.Code" [confirmButtonText]="''"
        (confirmed)="onConfirm(getOtpForm)" (canceled)="onCancel()"></app-confirmation-modal>
</div>